import React from 'react'
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';
import Parser from 'html-react-parser';

export default function Modal({ title, content, open, close, children }) {

    return (
        <Dialog
            open={open}
            onClose={close}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" sx={{fontWeight:'bold'}}>
                {Parser(title)}
            </DialogTitle>
            <DialogContent sx={{textAlign: "justify"}}>
                <DialogContentText id="alert-dialog-description">
                    {Parser(content)}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {children}
            </DialogActions>
        </Dialog>
    )
}
